import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FileText, Film, Mail } from "lucide-react";

const TABS = [
  { to: "/admin/blog", label: "المدونة", Icon: FileText, tid: "admin-tab-blog" },
  { to: "/admin/portfolio", label: "المحفظة", Icon: Film, tid: "admin-tab-portfolio" },
  { to: "/admin/newsletter", label: "المشتركين", Icon: Mail, tid: "admin-tab-newsletter" },
];

const AdminTabs = () => (
  <div className="flex items-center gap-1.5 flex-wrap" data-testid="admin-tabs">
    {TABS.map(({ to, label, Icon, tid }) => (
      <NavLink
        key={to}
        to={to}
        data-testid={tid}
        className={({ isActive }) =>
          `inline-flex items-center gap-2 px-3.5 py-2 rounded-full text-sm border transition ${
            isActive
              ? "bg-[#E6A95B] text-[#0A0A0C] border-[#E6A95B] font-bold"
              : "border-white/15 text-white/70 hover:text-[#E6A95B] hover:border-[#E6A95B]/60"
          }`
        }
      >
        <Icon className="w-4 h-4" />
        {label}
      </NavLink>
    ))}
  </div>
);

export default AdminTabs;
